import { render, staticRenderFns } from "./EditPush.vue?vue&type=template&id=228c6ba5&scoped=true"
import script from "./EditPush.vue?vue&type=script&lang=js"
export * from "./EditPush.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=1&id=228c6ba5&prod&scoped=true&lang=css&external"
import style2 from "bootstrap-vue/dist/bootstrap-vue.css?vue&type=style&index=2&id=228c6ba5&prod&scoped=true&lang=css&external"
import style3 from "./EditPush.vue?vue&type=style&index=3&id=228c6ba5&prod&lang=scss&scoped=true"
import style4 from "./EditPush.vue?vue&type=style&index=4&id=228c6ba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c6ba5",
  null
  
)

export default component.exports